import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_AUTH } from "config/connString";
import authHeader from "utils/authHeader";
import useAxios from "utils/useAxios";

const acceptUserAgreement = createAsyncThunk(
  "auth/accept-user-agreement",
  async (data) => {
    const api = useAxios();

    try {
      const response = await api.put(
        URL_AUTH + "user-agreement",
        {
          name: data.name,
          position: data.position,
        },
        authHeader()
      );

      return response.data;
    } catch (error) {
      return error.response;
    }
  }
);

export { acceptUserAgreement };
